import { Skeleton, Typography } from "@mui/material";
import {
  Box,
  ContentRepeater,
  FlexColBox,
} from "../../../../../common/components";
import { spacing } from "../../../../../styles/theme";

export const PreviewGlassMagnifierSkeleton = () => {
  return (
    <FlexColBox gap={spacing.smallDesktop}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={spacing.smallDesktop}>
          <ContentRepeater repeatCount={2}>
            <Skeleton
              variant="rounded"
              width={21}
              height={21}
              sx={{ borderRadius: "100%" }}
            />
          </ContentRepeater>
        </Box>
        <Typography variant="textSm">
          <Skeleton variant="text" width={75} height={14} />
        </Typography>
      </Box>
      <Skeleton variant="rounded" width={"100%"} height={300} />
    </FlexColBox>
  );
};
